import { render, staticRenderFns } from "./AddressProof.vue?vue&type=template&id=d62522e0&scoped=true&"
import script from "./AddressProof.vue?vue&type=script&lang=js&"
export * from "./AddressProof.vue?vue&type=script&lang=js&"
import style0 from "./AddressProof.vue?vue&type=style&index=0&id=d62522e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62522e0",
  null
  
)

export default component.exports